import { useEffect, useState } from 'react';
import type { Screen } from './types';

const TUTORIAL_DONE_KEY = 'nonogram_tutorial_done';

const PROMO_BASE_URL =
  import.meta.env.VITE_PROMO_URL || 'https://cross-promo.sliceof.games';
export const CROSS_PROMO_SRC = `${PROMO_BASE_URL}/banner?origin=nonogram&l=15`;

export const SIDE_AD_MIN_WIDTH = 160;
export const SIDE_AD_MIN_HEIGHT = 600;
const GAME_MAX_WIDTH = 728;

function isTutorialDone(): boolean {
  try {
    return localStorage.getItem(TUTORIAL_DONE_KEY) === '1';
  } catch {
    return false;
  }
}

function useTutorialDone(): boolean {
  const [done, setDone] = useState(isTutorialDone);
  useEffect(() => {
    function onStorage(e: StorageEvent) {
      if (e.key === TUTORIAL_DONE_KEY) setDone(isTutorialDone());
    }
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);
  return done;
}

/**
 * Decides if cross-promo should be shown and which slot to use.
 * Rules:
 *  - Only on home screen
 *  - Only after tutorial completed (not first session)
 *  - Single side slot: right column, only when viewport has enough room
 */
export type AdSlot = 'right' | null;

export function useCrossPromoSlot(
  screen: Screen,
  viewport: { vw: number; vh: number },
): AdSlot {
  const tutorialDone = useTutorialDone();
  if (screen.type !== 'home') return null;
  if (!tutorialDone) return null;

  const { vw, vh } = viewport;
  const sideSpace = (vw - GAME_MAX_WIDTH) / 2;
  if (sideSpace >= SIDE_AD_MIN_WIDTH + 24 && vh >= SIDE_AD_MIN_HEIGHT) return 'right';
  return null;
}
